<template>

</template>

<script>
export default {
    name: "activateDeviceTable"
}
</script>

<style scoped>

</style>
